module.exports = __webpack_public_path__ + "static/media/aragon20.c2931544.jpg";